<div *ngIf="show" class="wrapper">
    <div fxLayout="row" fxLayoutAlign="start center" class="search-container">
        <div *ngIf="query === ''" class="placeholder">Search</div>
        <input enterkeyhint="go" [(ngModel)]="query" #search type="text" (keypress)="onKeyPress($event)">
        <img (click)="goToSearch()" class="icon" src="assets/images/icon/search-icon.svg"/>
    </div>
    <div (click)="close()" class="area"></div>
</div>
